import { TextAssetSpec } from "@westpierstudio/luma/factory/PixiFactory";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Sprite, Text, Texture } from "pixi.js";
import { BoundedContainer, Bounds, implementBoundedContainer } from "utils/BoundedContainer";

export class WinBoxDev extends View {
    protected readonly box: Sprite;
    protected readonly valueBox: Sprite;
    protected readonly bonusCompleteBox: Sprite;
    protected readonly valueText: Text;
    protected readonly valueBounds: BoundedContainer;

    constructor(protected override services: GameServices, x: number, y: number, textures: { box: Texture, valueBox: Texture, bonusCompleteBox: Texture },
        valueBoxY: number, bonusCompleteY: number, textSpec: TextAssetSpec, bounds: Bounds, bonusCompleteBounds: Bounds) {
        super(services);

        const { factory, resources } = services;

        this.box = factory.createSpriteFromTexture(textures.box, { x, y, anchor: 0.5 }, this);
        this.valueBox = factory.createSpriteFromTexture(textures.valueBox, { x: 0, y: valueBoxY, anchor: 0.5 }, this.box);
        this.bonusCompleteBox = factory.createSpriteFromTexture(textures.bonusCompleteBox, { x: 0, y: bonusCompleteY, anchor: 0.5 }, this.box);
        this.valueBounds = implementBoundedContainer(this.valueText = factory.createText(``, textSpec, this.valueBox), bounds);
        implementBoundedContainer(factory.createText(resources.getMessage(`totalWinNoWinsText`), textSpec, this.bonusCompleteBox), bonusCompleteBounds);

        this.visible = false;
    }

    showValueBox(show: boolean) {
        this.valueBox.visible = show;
        this.bonusCompleteBox.visible = false;
    }

    setValue(value: number) {
        this.valueText.text = this.services.currency.formatCoins(
            value,
            { useSubUnits: true, group: true, addTrailingZeros: true, trimIntegers: false }
        );
        this.valueBounds.update();
    }

    setBonusComplete() {
        this.valueBox.visible = false;
        this.bonusCompleteBox.visible = true;
    }

    setColor(hex: number) {
        this.box.tint = hex;
        this.valueBox.tint = hex;
        this.bonusCompleteBox.tint = hex;
    }
}